const MyOfferIFrame = () => (
  <iframe title="MyOffer" height="100%" width="100%" src={import.meta.env.REACT_APP_MY_OFFER_URL} />
)

export default MyOfferIFrame
